import request from "project-config/services/request/request";

interface BillingApiParams {
  pageNum: number;
  pageSize: number;
}

export interface StatusApiParams {
  ids: Number[];
  selectAll: boolean;
}

export enum OperateTypeEnum {
  read,
  delete,
  readAll,
  deleteAll,
}

export enum Business {
  Setting,
  Task,
  BillAppeal = 2,
  Capital = 9,
}

export enum NotificationTabType {
  BillingMessage = "BillingMessage",
  AppealBillingMessage = "AppealBillingMessage",
  NotificationSetting = "NotificationSetting",
  CapitalMessage = "CapitalMessage",
}

export const NotificationModalTip = {
  [OperateTypeEnum.read]: {
    text: "notification_billing_operate_markread",
    selectAll: false,
  },
  [OperateTypeEnum.delete]: {
    text: "notification_billing_table_delete",
    selectAll: false,
  },
  [OperateTypeEnum.readAll]: {
    text: "notification_billing_operate_readall",
    selectAll: true,
  },
  [OperateTypeEnum.deleteAll]: {
    text: "notification_billing_operate_deleteall",
    selectAll: true,
  },
};

export const MarkApi = {
  [NotificationTabType.BillingMessage]: {
    markApi: "/api/rendering/user/consume/bill/markRead",
    markParams: (params: StatusApiParams) => ({
      ...params,
    }),
  },
  [NotificationTabType.AppealBillingMessage]: {
    markApi: "/api/rendering/message/markRead",
    markParams: (params: StatusApiParams) => ({
      business: Business.BillAppeal,
      ...params,
    }),
  },
  [NotificationTabType.CapitalMessage]: {
    markApi: "/api/rendering/message/markRead",
    markParams: (params: StatusApiParams) => ({
      business: Business.Capital,
      ...params,
    }),
  },
};

export const DeleteApi = {
  [NotificationTabType.BillingMessage]: {
    deleteApi: "/api/rendering/user/consume/bill/delUserBillsMessage",
    deleteParams: (params: StatusApiParams) => ({
      ...params,
    }),
  },
  [NotificationTabType.AppealBillingMessage]: {
    deleteApi: "/api/rendering/message/delete",
    deleteParams: (params: StatusApiParams) => ({
      business: Business.BillAppeal,
      ...params,
    }),
  },
};
export const QueryApiConfig = {
  [NotificationTabType.AppealBillingMessage]: {
    queryApi: "/api/rendering/message/messagegList",
    queryParams: (params: BillingApiParams) => ({
      business: Business.BillAppeal,
      ...params,
    }),
    queryStatisticsParams: () => ({ type: Business.Task }),
  },
  [NotificationTabType.BillingMessage]: {
    queryApi: "/api/rendering/user/consume/bill/getUserBillsMessageList",
    queryParams: (params: BillingApiParams) => params,
    queryStatisticsParams: () => ({ type: Business.BillAppeal }),
  },
};

export const NotificationSettingApi = {
  getBillMessageSetting: () => {
    return request.post("/api/rendering/message/getBillMessageSetting");
  },
  updateDayBillNotice: (params: any) => {
    return request.post("/api/rendering/message/updateDayBillNotice", params);
  },
  addBillNoticeEmail: (params: any) => {
    return request.post("/api/rendering/message/addBillNoticeEmail", params);
  },
  removeBillNoticeEmail: (params: any) => {
    return request.post("/api/rendering/message/removeBillNoticeEmail", params);
  },
};
